export default function getPropertyWaterActivities(ids?: number[]): number[] {
    if (!ids) return [];

    const result: number[] = [];

    if (ids.includes(60)) result.push(1); // Открытый бассейн
    if (ids.includes(59)) result.push(2); // Крытый бассейн
    if (ids.includes(174)) result.push(3); // Бассейн с подогревом
    if (ids.includes(173)) result.push(4); // Бассейн с морской водой
    if (ids.includes(175)) result.push(5); // Водные горки
    if (ids.includes(61)) result.push(6); // Аквапарк

    return result;
}
